import { useContext } from 'react';

import { OnboardingContext } from './OnboardingContext';

export const useOnboardingContext = () => {
  const context = useContext(OnboardingContext);

  if (context === null) {
    throw new Error('useOnboardingContext must be used within a OnboardingProvider');
  }

  return context;
};
